<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-27 15:10:09
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-09-26 14:27:06
 * @FilePath: \ces-vue-serve\src\views\contractCommonInput\regionAuto.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        区域：
      </div>
      <span class="required">*</span>：
      <div class="rj-baseinfo__item">
        <el-form-item prop="regionCode">
          <el-select
            ref="region"
            v-model="form.regionCode"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:100%;"
            @change="change"
          >
            <el-option
              v-for="item in list"
              :key="item.saleAreaID"
              :label="item.saleAreaName"
              :value="item.saleAreaID"
            />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getSaleArea } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getSaleArea(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      this.$nextTick(() => {
        this.form.regionName = this.$refs.region.selectedLabel;
      });
    },
    initData () {
      if (this.form.regionCode) {
        this.list = [{
          saleAreaName: this.form.regionName,
          saleAreaID: this.form.regionCode
        }];
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="less"></style>
